import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { normalizeItemChecklistFields } from "@web-app/pages/settings/FormBuilderTab/constants";
import type {
  OrderFormConfig,
  OrderFormField,
} from "@web-app/pages/settings/FormBuilderTab/types";

import {
  getOrderFormConfig,
  updateOrderFormConfig,
} from "../services/orderFormConfig";

// Module-level so react-query keeps the selected result stable between renders.
const normalizeConfig = (config: OrderFormConfig): OrderFormConfig =>
  config?.fields
    ? { ...config, fields: normalizeItemChecklistFields(config.fields) }
    : config;

export const useOrderFormConfig = ({ enabled = true } = {}) => {
  return useQuery({
    enabled,
    queryFn: getOrderFormConfig,
    queryKey: ["orderFormConfig"],
    refetchOnWindowFocus: false,
    select: normalizeConfig,
  });
};

export const useUpdateOrderFormConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fields: OrderFormField[]) => updateOrderFormConfig(fields),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orderFormConfig"] });
    },
  });
};
